import SubscriptionContent from "../content/subscriptionContent";
import Layout from "../layout/Layout";

export default function Subscription() {
  return (
    <Layout>
      <SubscriptionContent />
    </Layout>
  );
}
